import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ForgeBadge, ForgeButton, ForgeDivider, ForgeIcon, ForgeIconButton, ForgeMenu, ForgeTooltip } from '@tylertech/forge-react';
import { FiltersContext } from '../Filters/filterContext.js';
import { customForgeListItemRender } from './titleHelpers.js';

const HeaderButtons = ({ headerButtons }) => {
  const { numOfAppliedFilters } = useContext(FiltersContext);

  const getTooltip = (button) => (
    <ForgeTooltip anchor={button.id} placement="bottom">
      {button.tooltip}
    </ForgeTooltip>
  );

  return (
    <div className="header-buttons" slot={'end'}>
      {headerButtons && headerButtons.map((button) => {
        switch (button.type) {
          case 'dropDown':
            return (
              <React.Fragment key={button.id}>
                {button.before ? (
                  <ForgeDivider vertical style={{ height: '40px', marginLeft: 'var(--forge-spacing-xsmall)' }} />
                ) : null}
                <ForgeMenu
                  placement={'bottom-start'}
                  popupOffset={{
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: -100,
                  }}
                  options={button.children}
                  optionBuilder={customForgeListItemRender}
                  on-forge-menu-select={(e) => {
                    button.onClickFunction(e);
                  }}
                >
                  
                  <ForgeButton
                    aria-label={button.name}
                    popover-icon={button.popOverIcon}
                    variant={button.variant}
                    style={
                      button.style ? button.style : { marginLeft: '0px' }
                    }
                    className={`${button.before ? 'before' : ''}`}
                    disabled={button.disabled}
                  >
                    {button.icon &&
                      <ForgeIcon
                        external
                        slot={'start'}
                        externalType="all"
                        name={button.icon}
                      />
                    }
                    {button.name}
                  </ForgeButton>
                  {button.disabled ? getTooltip(button) : null}
                </ForgeMenu>
              </React.Fragment>
            );
          case 'iconButton':
            return (
              <React.Fragment key={button.id}>
                {button.before ? (
                  <ForgeDivider vertical style={{ height: '40px', marginLeft: 'var(--forge-spacing-xsmall)' }} />
                ) : null}
                <ForgeIconButton
                  onClick={button.onClickFunction}
                  style={
                    button.style ? button.style : { marginLeft: '0px' }
                  }
                  className={'opacity54'}
                  disabled={button.disabled}
                  id={button.id}
                  ariaLabel={button.name}
                >
                  <ForgeIcon
                    external
                    externalType="all"
                    name={button.icon}
                    className={'noPointerEvents'}
                  />
                </ForgeIconButton>
                <ForgeTooltip anchorId={button.id} position="left">
                  {button.tooltip}
                </ForgeTooltip>
                {button.disabled ? getTooltip(button) : null}
              </React.Fragment>
            );
          default:
            return (
              <React.Fragment key={button.id}>
                {button.before ? (
                  <ForgeDivider vertical style={{ height: '40px', marginLeft: 'var(--forge-spacing-xsmall)' }} />
                ) : null}
                {
                  button.useAiButton ?
                    (button.showCondition && <forge-ai-button
                      id={button.id}
                      onClick={button.onClickFunction}
                      {...(button.disabled && {['disabled']:button.disabled})}
                    >
                      {button.name}
                    </forge-ai-button>)
                    :
                    <ForgeButton
                      id={button.id}
                      disabled={button.disabled}
                      variant={button.variant}
                      style={{ margin: '0px 0px 0px var(--forge-spacing-xsmall)' }}
                      onClick={button.onClickFunction}
                    >
                      {button.icon ? (
                        <ForgeIcon
                          external
                          slot={'start'}
                          externalType="all"
                          name={button.icon}
                        />
                      ) : null}
                      {button.name}
                      {button.filterBadge && numOfAppliedFilters > 0 && (
                        <ForgeBadge>{numOfAppliedFilters}</ForgeBadge>
                      )}
                    </ForgeButton>
                }
                {button.disabled ? getTooltip(button) : null}
              </React.Fragment>
            );
        }
      })}
    </div >
  );
};

HeaderButtons.propTypes = {
  headerButtons: PropTypes.array,
};

export default HeaderButtons;
